module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJUlEQVQ4T2NgGBRAZHPUf3T856IYCj4nqIaBRw0YNWCQGTC0AQCYqWKkxIPfLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ML.png
// module id = 1208
// module chunks = 0